import { render, staticRenderFns } from "./ButtonLimparFiltros.vue?vue&type=template&id=b2c43604&"
import script from "./ButtonLimparFiltros.vue?vue&type=script&lang=js&"
export * from "./ButtonLimparFiltros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports